// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CardTileIntroMessageViewEvent
 */
export var CardTileIntroMessageView = function (_a) {
    var moneyVersion = _a.moneyVersion, cardTileState = _a.cardTileState;
    return ({
        name: "CardTile IntroMessage View",
        parameters: {
            cdf_entity: "CardTile",
            cdf_action: "IntroMessage",
            money_version: moneyVersion !== undefined && moneyVersion !== null ? moneyVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            card_tile_state: cardTileState !== undefined && cardTileState !== null ? cardTileState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
